export default "__VITE_ASSET___CFpuKLA__"